module.exports = require('./helpers/bundle-url').getBundleURL('e8Iy0') + "logo-dark.eefe0b7f.svg";